<template>
  <div>
    <div class="view-area">
      <div class="info-area">
        <img v-if="width > 639" src="@/assets/logo_b.png" class="info-title-img">
        <div class="description-area">
          <p class="text">株式会社あえか</p>
          <div class="folding-area">
            <p class="text mr-16">〒150-0012</p>
            <p class="text mr-16">東京都渋谷区広尾1-2-2</p>
            <p class="text">萩原ビル5F</p>
          </div>
          <a class="text underline" href="https://www.google.co.jp/maps/place/aeka+corporation/@35.6489472,139.7096776,17z/data=!3m1!4b1!4m5!3m4!1s0x60188b7a12fa8f95:0x777d140231fa5340!8m2!3d35.6489472!4d139.7118716?hl=ja" target="_blank">VIEW MAP</a>
          <div class="folding-area">
            <p class="text mr-16">T 03.3473.2088</p>
            <p class="text">F 03.5420.6781</p>
          </div>
          <br />
          <p class="text">代表取締役：稲井義哉</p>
        </div>
      </div>
    </div>
    <Footer />
    <Menu />
  </div>
</template>

<script>
import Footer from './modules/Footer'
import Menu from './modules/Menu'

export default {
  name: 'AboutUs',
  components: {
    Footer,
    Menu
  },
  data () {
    return {
      width: window.innerWidth
    }
  },
  methods: {
    handleResize () {
      this.width = window.innerWidth
    }
  },
  async mounted () {
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style scoped>
.view-area {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100vh;
  width: 100%;
}
@supports (-webkit-touch-callout: none) {
  .view-area {
    /* Safari用のハック */
    height: -webkit-fill-available;
  }
}
.info-area {
  display: flex;
  justify-content: center;
  margin-left: 192px;
  margin-bottom: 100px;
}
.folding-area {
  display: flex;
  flex-wrap: wrap;
}
.info-title-img {
  width: 192px;
  height: 239px;
  margin: 0 24px;
}
.description-area {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  margin: 0 24px 0 64px;
}
.text {
  font-size: 13px;
  color: #000;
  letter-spacing: 4.5px;
}
.underline {
  text-decoration: underline;
}
.mr-16 {
  margin-right: 16px;
}
@media (max-width: 639px) {
  .view-area {
    justify-content: flex-start;
  }
  .info-area {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-left: 32px;
  }
  .folding-area {
    flex-direction: column;
  }
  .description-area {
    margin: 24px 16px 0 16px;
  }
  .text {
    font-size: 11px;
    padding-bottom: 8px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AboutUs.vue